(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.media-tab').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var tab = btn.getAttribute('data-tab');
    document.querySelectorAll('.media-tab').forEach(function(t) { t.classList.remove('active'); });
    document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
    btn.classList.add('active');
    var panel = document.getElementById('tab-' + tab);
    if (panel) panel.classList.add('active');
  });
});

(function() {
  var canvas = document.getElementById('starfield');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var hero = canvas.closest('.hero');
  var stars = [], W, H, dpr = 1;

  function resize() {
    var w = hero ? hero.clientWidth : canvas.offsetWidth;
    var h = hero ? hero.clientHeight : canvas.offsetHeight;
    if (w < 1 || h < 1) return false;
    dpr = window.devicePixelRatio || 1;
    W = w;
    H = h;
    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return true;
  }

  function initStars() {
    stars = [];
    for (var i = 0; i < 220; i++) {
      stars.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 1.4 + 0.2, a: Math.random(), speed: Math.random() * 0.003 + 0.001, phase: Math.random() * Math.PI * 2, gold: Math.random() < 0.08 });
    }
  }

  function draw(t) {
    ctx.clearRect(0, 0, W, H);
    stars.forEach(function(s) {
      var alpha = s.a * (0.5 + 0.5 * Math.sin(t * s.speed * 1000 + s.phase));
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
      ctx.fillStyle = s.gold ? 'rgba(201,150,58,' + alpha + ')' : 'rgba(210,200,240,' + alpha + ')';
      ctx.fill();
    });
    requestAnimationFrame(draw);
  }

  function start() {
    if (!resize()) {
      requestAnimationFrame(start);
      return;
    }
    initStars();
    requestAnimationFrame(draw);
  }

  if (hero && window.ResizeObserver) {
    new ResizeObserver(function() {
      if (resize()) initStars();
    }).observe(hero);
  } else {
    window.addEventListener('resize', function() { if (resize()) initStars(); });
  }

  start();
})();

  } catch(e) { console.error(e); }
})();
})();
